var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.initLoading)?_c('FormCreator',{ref:"infoInputs",attrs:{"errors":_vm.errors,"popup":_vm.popup,"sections":_vm.formSections,"section":"infoInputs"},on:{"enter":function($event){return _vm.$emit('enter')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }